import React, { Component } from "react";
import Dashboard from "./Dashboard";
import { getUrlPadraoAtual, getUrlPadraoAtualMobile } from "../services/auth";
import DashboardTS from "./DashboardTS";

class DashboardAtual extends Component {
  render() {
    return (
      <DashboardTS
        URLDashboard="dashboardatual"
        history={this.props.history}
        pageName={getUrlPadraoAtual()}
        pageNameMobile={getUrlPadraoAtualMobile()}
      />
      // <Dashboard
      //   URLDashboard="dashboardatual"
      //   history={this.props.history}
      //   pageName={getUrlPadraoAtual()}
      //   pageNameMobile={getUrlPadraoAtualMobile()}
      // />
    );
  }
}

export default DashboardAtual;
